var redefine = require('../internals/redefine');

module.exports = function (target, src, options) {
  for (var key in src) redefine(target, key, src[key], options);
  return target;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/internals/redefine-all.js
// module id = 157
// module chunks = 0 1 5 7 8 9 21